export default "__VITE_ASSET__BzPraR7Q__"